import { render, staticRenderFns } from "./jobsreport.vue?vue&type=template&id=50b96d5e&scoped=true&"
import script from "./jobsreport.vue?vue&type=script&lang=js&"
export * from "./jobsreport.vue?vue&type=script&lang=js&"
import style0 from "./jobsreport.vue?vue&type=style&index=0&id=50b96d5e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b96d5e",
  null
  
)

export default component.exports